module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJklEQVQ4y2NgGBTgPxpgMKkEY0JgOBkA00AyppoBo7FAjWgc0gAATmD7SOikfaQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/FI.png
// module id = 1136
// module chunks = 0